module.exports = __webpack_public_path__ + "static/media/galgotias_logo.b2d255f2.jpeg";